export default __webpack_public_path__ + "static/media/alejandro-loguercio-sitting-smiling.b52247b4.jpg";